import { Skeleton } from '@/components/ui/skeleton';
import { PageHeaderSkeleton } from './PageHeaderSkeleton';
import { PageWrapper } from '@/components/layout';

/**
 * Skeleton for the Account page.
 */
export function AccountPageSkeleton() {
  return (
    <PageWrapper header={<PageHeaderSkeleton showDescription={true} showActions={true} />}>
      <div className="space-y-6 py-8">
        {/* Profile Section */}
        <div className="bg-card border border-border rounded-lg p-6 space-y-4">
          <div className="flex items-center gap-4">
            <Skeleton className="h-20 w-20 rounded-full" />
            <div className="flex-1 space-y-2">
              <Skeleton className="h-6 w-40" />
              <Skeleton className="h-4 w-56" />
            </div>
            <Skeleton className="h-10 w-28" />
          </div>
        </div>

        {/* Subscription Section */}
        <div className="bg-card border border-border rounded-lg p-6 space-y-4">
          <Skeleton className="h-6 w-32" />
          <div className="flex items-center justify-between">
            <div className="space-y-2">
              <Skeleton className="h-5 w-24" />
              <Skeleton className="h-4 w-48" />
            </div>
            <Skeleton className="h-10 w-32" />
          </div>
        </div>

        {/* Settings Section */}
        <div className="bg-card border border-border rounded-lg p-6 space-y-4">
          <Skeleton className="h-6 w-24" />
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="flex items-center justify-between py-2">
              <div className="space-y-1">
                <Skeleton className="h-5 w-32" />
                <Skeleton className="h-4 w-48" />
              </div>
              <Skeleton className="h-6 w-12" />
            </div>
          ))}
        </div>

        {/* Danger Zone */}
        <div className="bg-card border border-error-200 rounded-lg p-6 space-y-4">
          <Skeleton className="h-6 w-28" />
          <Skeleton className="h-4 w-64" />
          <Skeleton className="h-10 w-36" />
        </div>
      </div>
    </PageWrapper>
  );
}
